"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var AffilateEmailTemplateTplRawEditor_1 = require("./AffilateEmailTemplateTplRawEditor");
var AffilateEmailTemplateImagesList_1 = require("./AffilateEmailTemplateImagesList");
var AffilateEmailTemplateImageEditor_1 = require("./AffilateEmailTemplateImageEditor");
var AffilateEmailTemplateTestJSONEditor_1 = require("./AffilateEmailTemplateTestJSONEditor");
var AffilateEmailTemplateOperationEdit = /** @class */ (function (_super) {
    __extends(AffilateEmailTemplateOperationEdit, _super);
    function AffilateEmailTemplateOperationEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_template = "tab.template";
        _this.tab_images = "tab.images";
        _this.tab_test = "tab.test";
        return _this;
    }
    AffilateEmailTemplateOperationEdit.prototype.componentWillMount = function () {
        this.setState({
            templateImageMode: "LIST",
            templateImageRecord: null
        });
        this.props.state.setExtBreadCrumbPath(["Управление шаблоном"]);
    };
    AffilateEmailTemplateOperationEdit.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    AffilateEmailTemplateOperationEdit.prototype.newTemplateImageClick = function () {
        this.setState({ templateImageMode: "NEW", templateImageRecord: null });
    };
    AffilateEmailTemplateOperationEdit.prototype.editAppCurrencyClick = function (record) {
        this.setState({ templateImageMode: "EDIT", templateImageRecord: record });
    };
    AffilateEmailTemplateOperationEdit.prototype.backToImagesListClick = function () {
        this.setState({ templateImageMode: "LIST", templateImageRecord: null });
    };
    AffilateEmailTemplateOperationEdit.prototype.getTemplateImagesObject = function () {
        if (this.state.templateImageMode === "LIST") {
            return (React.createElement(AffilateEmailTemplateImagesList_1.default, { state: this.props.state, data: this.props.dataImages, onNewClick: this.newTemplateImageClick.bind(this), onEditClick: this.editAppCurrencyClick.bind(this), onGoBack: this.backToRootClick.bind(this), record: this.props.record }));
        }
        if (this.state.templateImageMode === "NEW") {
            return (React.createElement(AffilateEmailTemplateImageEditor_1.default, { data: this.props.dataImages, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToImagesListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.templateImageMode === "EDIT") {
            return (React.createElement(AffilateEmailTemplateImageEditor_1.default, { data: this.props.dataImages, record: this.state.templateImageRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToImagesListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        throw "No available render for active edit mode -> " + this.state.templateImageMode;
    };
    AffilateEmailTemplateOperationEdit.prototype.getTPLRawEditorObject = function () {
        return (React.createElement(AffilateEmailTemplateTplRawEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), tplBase64: this.props.TPLBase64 }));
    };
    AffilateEmailTemplateOperationEdit.prototype.getTestJSONEditorObject = function () {
        return (React.createElement(AffilateEmailTemplateTestJSONEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), testJSONBase64: this.props.JSONBase64 }));
    };
    AffilateEmailTemplateOperationEdit.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_template },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "envelope" }),
                        "\u0428\u0430\u0431\u043B\u043E\u043D"), key: this.tab_template }, this.getTPLRawEditorObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "images" }),
                        "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"), key: this.tab_images }, this.getTemplateImagesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "calendar-check" }),
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"), key: this.tab_test }, this.getTestJSONEditorObject()))));
    };
    return AffilateEmailTemplateOperationEdit;
}(React.Component));
exports.default = AffilateEmailTemplateOperationEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/email/AffilateEmailTemplateOperations.tsx
// module id = 2032
// module chunks = 0